<template>
  <div class="mk-phonebottom2-footer">
    <div class="animate_top index-quality-box">
      <h2>{{childItem.propsValue.data.customField6}}</h2>
      <div class="index-quality-form">
        <img class="index-quality-form-phone" src="./../../../../../assets/img/phone.png" alt />
        <input
          class="index-quality-form-input"
          id="index-quality-form"
          maxlength="11"
          type="text"
          placeholder="请输入手机号码"
        />
        <div class="index-quality-form-line"></div>
        <button class="index-quality-form-btn">免费体检</button>
      </div>
      <ul class="index-quality-list">
        <li>
          <img src="./../../../../../assets/img/foot_right.png" alt /> {{childItem.propsValue.data.customField7}}
        </li>
        <li>
          <img src="./../../../../../assets/img/foot_right.png" alt /> {{childItem.propsValue.data.customField8}}
        </li>
        <li>
          <img src="./../../../../../assets/img/foot_right.png" alt /> {{childItem.propsValue.data.customField9}}
        </li>
        <li>
          <img src="./../../../../../assets/img/foot_right.png" alt /> {{childItem.propsValue.data.customField10}}
        </li>
      </ul>
    </div>
    <div class="animate_top rightInfo">
      <img :src="childItem.propsValue.data.customField2" alt />
      <div>
        <p v-if="childItem.propsValue.data.customField3">{{childItem.propsValue.data.customField3}}</p>
        <span></span>
        <ul>
          <li v-if="childItem.propsValue.data.customField4">{{childItem.propsValue.data.customField4}}</li>
          <li v-if="childItem.propsValue.data.customField5">{{childItem.propsValue.data.customField5}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formObject
} from "../../../../../config/elementObject.js";
let formObjectTemp = JSON.parse(JSON.stringify(formObject));
export default {
  name: "MkPhonebottom2Web",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "表单",
          type: "form"
        },
        {
          code: "customField6",
          label: "标题",
          type: "text"
        },
        {
          code: "customField7",
          label: "描述1",
          type: "text"
        },
        {
          code: "customField8",
          label: "描述2",
          type: "text"
        },
        {
          code: "customField9",
          label: "描述3",
          type: "text"
        },
        {
          code: "customField10",
          label: "描述4",
          type: "text"
        },
        {
          code: "customField2",
          label: "二维码",
          type: "image",
          width: 130,
          height: 130
        },
        {
          code: "customField3",
          label: "二维码标题",
          type: "text"
        },
        {
          code: "customField4",
          label: "二维码描述1",
          type: "text"
        },
        {
          code: "customField5",
          label: "二维码描述2",
          type: "text"
        }
      ],
      data: {
        customField1: formObjectTemp,
        customField6: "品质选择，值得信赖",
        customField7: "免费上门或线上产品演示",
        customField8: "专业客户顾问全程服务",
        customField9: "企业定制化解决方案",
        customField10: "全天候业务咨询服务",
        customField2: "https://mks.yybip.com/group1/M00/09/13/CgoRC2NfZPKAflrjAAGDf8VcmM4595.png",
        customField3: "扫码加入社群",
        customField4: "与财务领域精英共同成长",
        customField5: "获取财务数智化转型白皮书"

      }
    };
  }
};
</script>


<style lang="scss" scoped>
.mk-phonebottom2-footer {
  background-size: 100% 100%;
  height: 100%;
  background: url("https://mks.yybip.com/group1/M00/01/64/CgoRDGNfZYWAfA02AAO0fTysHSE452.png")
    #fff no-repeat center center;
  display: flex;
  justify-content: center;
  padding: 60px 0;
  .index-quality-box {
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    width: 500px;
    h2 {
      padding: 0;
      margin-bottom: 24px;
      margin-top: 10px;
      font-size: 24px;
      color: #ffffff;
      font-weight: bold;
      text-align: center;
    }
    .index-quality-form {
      width: 400px;
      height: 50px;
      align-items: center;
      margin: 0 auto;
      background-color: #ffffff;
      border-radius: 6px;
      border: solid 1px #fdddd3;
      display: flex;
      .index-quality-form-input {
        border: none;
      }
      .index-quality-form-input:focus {
        outline: none;
        border: none !important;
      }
      .index-quality-form-phone {
        width: 18px;
        height: 20px;
        height: 20px;
        margin-left: 23px;
        margin-right: 9px;
      }
      .index-quality-form-line {
        width: 1px;
        height: 22px;
        color: #979797;
        display: none;
      }
      .index-quality-form-btn {
        font-size: 16px;
        color: #e60012;
        font-weight: 400;
        border: none;
        margin-left: 70px;
        background: none;
        letter-spacing: 1px;
        line-height: 26px;
        border-left: 1px solid #979797;
        padding: 0 10px;
        margin-right: 1px;
      }
    }

    .index-quality-list {
      width: 400px;
      margin: 10px auto;
      li {
        font-size: 12px;
        min-width: 200px;
        padding: 0;
        float: left;
        color: #fff1f2;
        line-height: 26px;
      }
      img {
        width: 14px;
        height: 10px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
  }

  .rightInfo {
    display: flex;
    margin: auto 30px;
    img {
      width: 133px;
      height: 133px;
      margin-right: 20px;
    }
    p {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    span {
      display: inline-block;
      width: 102px;
      height: 2px;
      background: #ffffff;
      margin: 14px 0;
      border-radius: 2px;
    }
    ul {
      padding-left: 20px;
    }
    li {
      font-size: 14px;
      color: #ffffff;
      line-height: 25px;
      list-style-type: disc;
    }
  }
}
</style>
